jQuery(document).ready(function () {
  // capitalize heading words for 'terms of services'
  var termsOfServices = jQuery(
    ".shopify-policy__container .shopify-policy__title h1"
  );
  if (termsOfServices.length) {
    var textContent = termsOfServices.text();
    if (textContent.toLowerCase() === "terms of service") {
      termsOfServices.text("Terms of Service");
    }
  }

  // intro-width-video-background started
  let smallScreenVideo = jQuery(".background__video__smaller__screen").get(0);
  let introSectionWrapper = jQuery(".intro__section__wrapper");

  if (smallScreenVideo) {
    if (/Mobi|Tablet|Android/i.test(navigator.userAgent)) {
      introSectionWrapper.css("background-color", "black");
      smallScreenVideo.addEventListener("loadeddata", function () {
        console.log("loaded data");
        smallScreenVideo.addEventListener("playing", function () {
          setInterval(function () {
            if (smallScreenVideo.readyState >= 4) {
              smallScreenVideo.style.opacity = "1";
              jQuery(smallScreenVideo).attr({
                autoplay: true,
                loop: true,
                muted: true,
              });
              introSectionWrapper.css("background-color", "transparent");
              smallScreenVideo.style.display = "block";
            }
          }, 500);
        });
      });
    }
  }

  if (window.innerWidth > 992) {
    introSectionWrapper.css("background-color", "transparent");
  }

  // intro-width-video-background ended

  // Replace announcement bar if customer subscription is true
  // const customerInfo = JSON.parse(window.localStorage.getItem("customerInfo"));

  // if (customerInfo?.subscriptionStatus === true) {
  //   function updateAnnoucementBarContent() {
  //     let announcementBar = jQuery("#qab_container");
  //     let annoucementBarContent = jQuery("#qab_content");
  //     let navbar = jQuery(".custom__header__wrapper");
  //     let declinedMessage = `Welcome back ${customerInfo?.firstName} ${customerInfo?.lastName}! Your card has declined, please update the your details.`;
  //     let welcomeMessage = `Welcome back ${customerInfo?.firstName} ${customerInfo?.lastName}! Membership pricing has been applied`;
  //     let welcome =
  //       customerInfo?.cardDeclinedStatus === true
  //         ? declinedMessage
  //         : welcomeMessage;
  //     if (announcementBar.length) {
  //       announcementBar
  //         .attr("id", "qad_container-replace-content")
  //         .css("height", "44px");
  //       navbar.css("top", announcementBar.height());
  //       annoucementBarContent.html(`<span>${welcome}</span>`);
  //     } else {
  //       setTimeout(updateAnnoucementBarContent, 1000);
  //     }
  //   }
  //   setTimeout(updateAnnoucementBarContent, 1000);
  // }

  // sticky navbar script
  function handleStickyNavbar() {
    var navbar = jQuery(".custom__header__wrapper");
    var qabBackground = jQuery("#qab_background");
    var qab_container = jQuery("#qab_container");
    var qad_containerCustom = jQuery("#qad_container-replace-content");
    var pageMainTrackUrl = "/pages/main-go-karting-track";
    var pageMiniTrackUrl = "/pages/kids-go-karting-track";
    var pageHyperReality = "/pages/hyper-reality";
    var dynamicUrl = window.location.pathname;
    const announcementBar = jQuery(".announcement-bar-section");
    
    if (
      (window.HKBooking && window.HKBooking.isBookingPath(dynamicUrl)) ||
      dynamicUrl === pageMainTrackUrl ||
      dynamicUrl === pageMiniTrackUrl ||
      dynamicUrl === pageHyperReality ||
      dynamicUrl.endsWith("mt") ||
      dynamicUrl.endsWith("mi") ||
      dynamicUrl.endsWith("vr") ||
      dynamicUrl.endsWith("summer-championship-morning") ||
      dynamicUrl.endsWith("summer-championship-evening")
    ) {
      qab_container.css("display", "none");
      qad_containerCustom.css("display", "none");
    }

    if (navbar.hasClass("sticky__navbar")) {
      var announcementBarHeight = announcementBar.length ? announcementBar.outerHeight() : 0;
      
      if (qabBackground.length > 0) {
        qabBackground.css("position", "fixed");
      }
      
      if (jQuery(window).scrollTop() === 0) {
        announcementBar.closest('#shopify-section-announcement-bar').css("display", "block");
        qad_containerCustom.css("display", "block");
        qab_container.css("display", "block");
        announcementBarHeight = announcementBar.length ? announcementBar.outerHeight() : 0;
        navbar.css("top", announcementBarHeight);
      } else {
        announcementBar.closest('#shopify-section-announcement-bar').css("display", "none");
        navbar.css("top", 0);
      }
    }
  }

  jQuery(window).on("scroll resize", handleStickyNavbar);
  handleStickyNavbar();

  // Main/Mini track buttons
  jQuery(".primary__button__wrapper").on("click", function () {
    jQuery(".primary__button__wrapper").removeClass("primary__linear__bg");
    jQuery(this).addClass("primary__linear__bg");
  });
  // Define a function to switch tabs
  // Define a function to switch tabs
  function switchTabs(
    $tabLinks,
    $tabContents,
    $currentTabLink,
    $currentTabContent
  ) {
    $tabLinks.removeClass("current");
    $tabContents.removeClass("current");

    if ($currentTabLink.attr("data-tab") === "tab-2") {
      jQuery("#tab-1").addClass("none");
      jQuery("#tab-2").removeClass("none");
    } else {
      jQuery("#tab-1").removeClass("none");
      jQuery("#tab-2").addClass("none");
    }

    $currentTabLink.addClass("current");
    $currentTabContent.addClass("current");
  }

  // Switch tabs on click
  jQuery("div.tabs .tab-link").click(function () {
    var $tabLink = jQuery(this);
    var $tabContent = jQuery("#" + $tabLink.attr("data-tab"));

    // Switch tab contents based on the data-tab attribute of the tab link
    if ($tabLink.attr("data-tab") === "tab-1") {
      jQuery("#general-enquiry-form-wrapper").css("display", "block");
      jQuery("#corporate-enquiry-form-wrapper").css("display", "none");
    } else {
      jQuery("#general-enquiry-form-wrapper").css("display", "none");
      jQuery("#corporate-enquiry-form-wrapper").css("display", "block");
    }

    switchTabs(
      jQuery("div.tabs .tab-link"),
      jQuery(".tab-content"),
      $tabLink,
      $tabContent
    );
  });

  // Navbar dropdown conflict
  var navbarLinks = jQuery(".navbar__menu__header .navbar-nav .nav-item");

  navbarLinks.hover(
    function () {
      jQuery(this).find(".dropdown-menu").addClass("show");
    },
    function () {
      jQuery(this).find(".dropdown-menu").removeClass("show");
    }
  );
  // Dropdown menu Table/Mobile
  jQuery(".mobile__show__dropdrop__menu").click(function () {
    jQuery(this).next(".dropdown-menu").toggleClass("show");
    jQuery(this).toggleClass("mobile__show__open");
  });
  // Check for iOS devices
  var isIOS = /iPad|iPhone/.test(navigator.userAgent) && !window.MSStream;
  // Determine if device is an iPhone, iPad

  // Define function to update input's value on change
  function updateInputValue() {
    var $input = jQuery(this);
    $input.attr("value", $input.val());
  }

  if (isIOS) {
    // Set today's date as the default value for start date inputs
    var today = new Date().toISOString().slice(0, 10);
    jQuery("input.input_cust").val(today);

    // Add event listener to date picker inputs to update value on change
    jQuery("input.input_cust").on("change", updateInputValue);
  } else {
    // Add event listeners to date picker inputs to update value on change
    jQuery("input.input_cust")
      .on("change", function () {
        var momentDate = moment(this.value, "YYYY-MM-DD");
        var dateFormat = this.getAttribute("data-date-format");
        this.setAttribute("data-date", momentDate.format(dateFormat));
      })
      .on("input", updateInputValue);
    // Set today's date as the default value for start date inputs
    var today = moment().format("dddd, Do MMMM YYYY");
    jQuery("#startDate, #book__now__date__picker")
      .attr("data-date", today)
      .val(today);
  }

  // Switch tabs on click
  jQuery("ul.tabs1 li").click(function () {
    console.log("clicked");
    var $tabLink = jQuery(this);
    var $tabContent = jQuery("#" + $tabLink.attr("data-tab"));
    
    // Get the section ID from the parent ul to scope tab switching to this section only
    var sectionId = $tabLink.closest("ul.tabs1").data("section-id");
    var $sectionTabLinks, $sectionTabContents;
    
    if (sectionId) {
      // For sections with data-section-id (content-navigation-v2.liquid)
      $sectionTabLinks = jQuery("ul.tabs1[data-section-id='" + sectionId + "'] li");
      $sectionTabContents = jQuery(".tab-content1[id*='info-tab-" + sectionId + "-']");
    } else {
      // For sections without data-section-id (content-navigation.liquid, accordion-info.liquid)
      // Find the closest container and scope tabs to that container only
      var $container = $tabLink.closest(".info__section-wrapper, .accodion__info__wrapper");
      $sectionTabLinks = $container.find("ul.tabs1 li");
      $sectionTabContents = $container.find(".tab-content1");
    }
    
    switchTabs($sectionTabLinks, $sectionTabContents, $tabLink, $tabContent);
  });

  // Show/hide table rows on click
  jQuery(".week1Table .more-button-show").click(function () {
    jQuery(this)
      .closest(".week1Table")
      .find(".slide-down-row")
      .removeClass("d-none");
    jQuery(this).addClass("d-none");
    jQuery(this).siblings(".less-button-show").removeClass("d-none");
  });
  jQuery(".week1Table .less-button-show").click(function () {
    jQuery(this).closest(".week1Table").find(".slide-down-row").addClass("d-none");
    jQuery(this).addClass("d-none");
    jQuery(this).siblings(".more-button-show").removeClass("d-none");
  });

  // Switch league options on click
  jQuery(".option-league").click(function () {
    var leagueHtml = jQuery(this).attr("data-league");
    jQuery(".accordion-item .select-league").addClass("d-none d-flex");
    jQuery(
      '.accordion-item .select-league[data-league="' + leagueHtml + '"]'
    ).removeClass("d-none");
  });

  // Highlight selected race championship tab
  jQuery(".races-chapionships46 .nav-item .background-wrapper-tab").click(
    function () {
      jQuery(".races-chapionships46 .nav-item .background-wrapper-tab").removeClass(
        "primary__linear__bg"
      );
      jQuery(this).addClass("primary__linear__bg");
    }
  );

  // Script for championship landing - section: book now
  // Get the data-book-now-link value of the first button wrapper
  var defaultBookNowLink = jQuery(
    ".book__now__championship__wrapper .primary__button__wrapper"
  )
    .eq(0)
    .data("book-now-link");

  // Create the href with the prefix '/products/summer-championship-' and default book now link
  var defaultHref =
    "/products/summer-championship-" + defaultBookNowLink?.toLowerCase();
  // Set the default href of the book__now__link__click element
  jQuery(".book__now__championship__wrapper .book__now__link__click a").attr(
    "href",
    defaultHref
  );

  // When a primary__button__wrapper element is clicked
  jQuery(".book__now__championship__wrapper .primary__button__wrapper").on(
    "click",
    function () {
      // Get the data-book-now-link value
      var bookNowLink = jQuery(this).data("book-now-link");

      // Create the href with the prefix '/products/summer-championship-'
      var href = "/products/summer-championship-" + bookNowLink?.toLowerCase();

      // Set the href of the book__now__link__click element
      jQuery(".book__now__championship__wrapper .book__now__link__click a").attr(
        "href",
        href
      );
    }
  );
  // intro-width-video-background and ready-to-race.liquid script
  var today = moment().format("YYYY-MM-DD");
  jQuery("#book__now__date__picker").attr("type", "date").val(today);
  jQuery("#intro__book__now__date__picker").attr("type", "date").val(today);

  function generateProductId(startDate, trackType) {
    // Split the selected date into year, month, and day
    var dateParts = startDate.split("-");
    var startYear = dateParts[0].slice(2); // only the last two digits of the year
    var startMonth = dateParts[1];
    var startDay = dateParts[2];

    // Generate the product ID by concatenating the year, month, day, and track type
    var productId = startYear + startMonth + startDay;

    if (trackType.includes("mini")) {
      productId = "0" + productId + "mi";
    } else if (trackType.includes("main")) {
      productId += "mt";
    } else if (trackType.includes("virtual")) {
      productId += "vr";
    }

    return productId;
  }

  // function to handle video background based on the active track button

  function handleIntroVideoBackground(trackType) {
    var videoContainer = jQuery(".video__bg__container");
    var videoElements = videoContainer
      .find("video")
      .not(".background__video__smaller__screen");

    videoElements.each(function () {
      var videoElement = jQuery(this);
      var videoClassList = videoElement.attr("class").split("-");

      var trackTypeParts = trackType.split(" ");
      var containsTrackType = false;

      // Check if the first element of trackType matches the video class
      if (trackTypeParts[0] === videoClassList[0]) {
        containsTrackType = true;
      }

      if (containsTrackType) {
        // Show the video
        videoElement.addClass("show__element");
        videoElement.removeClass("hide__element");
        videoElement.get(0).play(); // Play the video
      } else {
        // Hide the video
        videoElement.removeClass("show__element");
        videoElement.addClass("hide__element");
        videoElement.get(0).pause(); // Pause the video
      }
    });
  }

  // function to handle one of three images based on the active track button

  function introHandleImage(trackType) {
    var imageContainer = jQuery(".karting__photo__smaller__view");
    var imageElements = imageContainer.find("img");

    imageElements.each(function () {
      var imageElement = jQuery(this);
      var imageClassList = imageElement.attr("class").split(/[\s-_]+/);

      var filteredClassList = imageClassList.filter(function (className) {
        return trackType.includes(className);
      });

      if (filteredClassList.length > 0) {
        if (filteredClassList.join(" ") === trackType) {
          // Show the image
          imageElement.removeClass("hide__element");
          imageElement.addClass("show__element");
        } else {
          // Hide the image
          imageElement.removeClass("show__element");
          imageElement.addClass("hide__element");
        }
      } else {
        // Hide the image
        imageElement.removeClass("show__element");
        imageElement.addClass("hide__element");
      }
    });
  }

  // Set the initial href value for the primary button

  function updatePrimaryButtonHref(startDate, trackType, primaryButtonClass) {
    // Get the corresponding primary button and set its href attribute
    var primaryBtn = jQuery("." + primaryButtonClass + "[data-set-href-attribute]");
    var hrefValue = "";

    // Generate the product ID based on the selected date and track type
    var productId = generateProductId(startDate, trackType);

    hrefValue = "/products/" + productId;
    primaryBtn.attr("href", hrefValue);

    // video handler function
    handleIntroVideoBackground(trackType);
    introHandleImage(trackType);
  }

  updatePrimaryButtonHref(today, "main", "intro-primary-button");
  updatePrimaryButtonHref(today, "main", "ready-to-race-primary-button");

  // Add event listener for the date picker change event
  jQuery("#intro__book__now__date__picker").change(function () {
    // Get the selected date from the input
    var startDate = jQuery(this).val();

    // Get the selected track type from the button with the .selected__track__active class
    var trackType = jQuery(".active[aria-selected=true]")
      .text()
      .trim()
      .toLowerCase();
    // Generate the product ID based on the selected date and track type, and update the primary button href
    updatePrimaryButtonHref(startDate, trackType, "intro-primary-button");
  });

  jQuery("#book__now__date__picker").change(function () {
    // Get the selected date from the input
    var startDate = jQuery(this).val();

    // Get the selected track type from the button with the .selected__track__active class
    var trackType = jQuery(".selected__track__active").text().trim().toLowerCase();
    // Generate the product ID based on the selected date and track type, and update the primary button href
    updatePrimaryButtonHref(
      startDate,
      trackType,
      "ready-to-race-primary-button"
    );
  });

  // Check if there is a selected track, if not, select the first one and add the active class
  jQuery(".ready__to__race__button__bg button").removeClass(
    "selected__track__active"
  );
  if (
    !jQuery(".ready__to__race__button__bg button.selected__track__active").length
  ) {
    var $mainTrackButton = jQuery(
      ".ready__to__race__button__bg button[data-track-type='Main Track']"
    );
    if ($mainTrackButton.length) {
      $mainTrackButton.addClass("selected__track__active");
    } else {
      jQuery(".ready__to__race__button__bg button:first-of-type").addClass(
        "selected__track__active"
      );
    }
  }

  // Handle button click event
  jQuery(".intro__track__buttons .primary__button__wrapper button").click(
    function () {
      // Get the selected date from the input
      var startDate = jQuery("#intro__book__now__date__picker").val();

      // Get the selected track type
      var trackType = jQuery(this).text().trim().toLowerCase();
      // Generate the product ID based on the selected date and track type, and update the primary button href
      updatePrimaryButtonHref(startDate, trackType, "intro-primary-button");
    }
  );

  jQuery(
    ".ready__to__race__smaller__screen .ready__to__race__wrapper__button__wrapper button"
  ).click(function () {
    // Remove the active class from other buttons
    jQuery(
      ".ready__to__race__smaller__screen .ready__to__race__wrapper__button__wrapper button"
    ).removeClass("selected__track__active");

    // Add the active class to the clicked button
    jQuery(this).addClass("selected__track__active");

    // Get the selected date from the input
    var startDate = jQuery("#book__now__date__picker").val();

    // Get the selected track type
    var trackType = jQuery(this).text().trim().toLowerCase();

    // Generate the product ID based on the selected date and track type, and update the primary button href
    updatePrimaryButtonHref(
      startDate,
      trackType,
      "ready-to-race-primary-button"
    );

    // Add the ready__to__race__wrapper__linear__bg class to the parent element of the clicked button
    jQuery(this).parent().addClass("ready__to__race__wrapper__linear__bg");

    // Remove the ready__to__race__wrapper__linear__bg class from all other parent elements
    jQuery(this)
      .parent()
      .siblings()
      .removeClass("ready__to__race__wrapper__linear__bg");
  });

  jQuery(".ready__to__race__wrapper__button__wrapper").click(function () {
    // Get the value of the data-book-now-link attribute of the clicked button wrapper
    var bookNowLink = jQuery(this).attr("data-book-now-link");
  });

  jQuery(".accordion__group__wrapper .accordion__button").on("click", function () {
    const expanded = jQuery(this).attr("aria-expanded") === "true";
    const dataSelector = jQuery(this).attr("aria-controls");
    jQuery(this).attr("aria-expanded", !expanded);
    jQuery(this).find(".plus-icon").toggleClass("hide-icon");
    jQuery(this).find(".minus-icon").toggleClass("hide-icon");
    jQuery(`#${dataSelector}`).css("display", expanded ? "none" : "block");
  });
  // Toggle Mini Cart
  jQuery(".show__mini__cart__details").click(function () {
    jQuery(".dropdown__menu__wrapper").toggleClass("dropdown__menu__display__show");
  });

  jQuery(".show__mini__cart__mobile").click(function () {
    jQuery(".dropdown__menu__wrapper__mobile").toggle();
  });

  // Listen for updates

  window.addEventListener('cart:updated', function(event) {
    const data = event.detail;
    if (data.cart.item_count === 0) {
      if(document.querySelector(".mini__cart__mobile__show__total__purple")){
        document.querySelector(".mini__cart__mobile__show__total__purple").style.display = "none";
        document.querySelector(".mini__header__item__total").textContent = `Your Cart (${data.cart.item_count})`;
      }
    } else {
      const mobileShowTotal = document.querySelector(".mini__cart__mobile__show__total__purple");
      if(mobileShowTotal) {
        mobileShowTotal.style.display = "block";
        mobileShowTotal.textContent = `${data.cart.item_count}`;
        document.querySelector(".mini__header__item__total").textContent = `Your Cart (${data.cart.item_count})`;
      }
    }
  });
  

  // Mini Cart window level callback function

  let isMiniCartInitialized = false;

  function miniCartCallback(displayMiniCart = true) {
    const endpoint = "/?view=cart";

    jQuery.ajax({
      url: endpoint,
      method: "GET",
      dataType: "text",
      success: function (data) {
        const $data = jQuery(data);
        const itemTotalText = $data.find(".mini__header__item__total").text();
        const itemTotal = parseInt(itemTotalText.match(/\d+/)[0]);
        const isCartEmpty = itemTotal === 0;

        if (itemTotal === 0) {
          jQuery(".mini__cart__mobile__show__total__purple").css("display", "none");
        } else {
          jQuery(".mini__cart__mobile__show__total__purple")
            .css("display", "block")
            .text(`${itemTotal}`);
        }

        const wrapper = jQuery(".dropdown__menu__wrapper");
        const wrapperMoible = jQuery(".dropdown__menu__wrapper__mobile");
        
        wrapper.html(data);
        wrapperMoible.html(data);

        if (isCartEmpty) {
          if (!isMiniCartInitialized) {
            jQuery(".cart__details__wrapper").css("display", "none");
            jQuery(".mini__cart__empty").css("display", "block");
            if (jQuery(".mini__cart__upsell")[0]){
              jQuery(".mini__cart__upsell").css("display", "none");
            }
          } else {
            wrapper.removeClass("dropdown__menu__display__show");
            if (displayMiniCart) {
              wrapperMoible.toggle();
            }
            jQuery(".cart__details__wrapper").css("display", "none");
            jQuery(".mini__cart__empty").css("display", "block");
            if (jQuery(".mini__cart__upsell")[0]){
              jQuery(".mini__cart__upsell").css("display", "none");
            }
          }
        } else {
          if (!isMiniCartInitialized) {
            jQuery(".mini__cart__empty").css("display", "none");
            jQuery(".cart__details__wrapper").css("display", "block");
            if (jQuery(".mini__cart__upsell")[0]){
              jQuery(".mini__cart__upsell").css("display", "block");
            }
          } else {
            wrapper.addClass("dropdown__menu__display__show");
            if (displayMiniCart) {
              wrapperMoible.toggle();
            }
            jQuery(".mini__cart__empty").css("display", "none");
            jQuery(".cart__details__wrapper").css("display", "block");
            if (jQuery(".mini__cart__upsell")[0]){
              jQuery(".mini__cart__upsell").css("display", "block");
            }
          }
        }
        isMiniCartInitialized = true;
      },
      error: function (xhr, status, error) {
        console.error("Error:", error);
      },
    });
  }

  window.miniCartCallback = miniCartCallback;
  window.miniCartCallback();

  // Product template related variables - membership use case only
  let membershipAgreement = jQuery(".membershipAgreement");
  let shopifyPaymentButton = jQuery(".shopify-payment-button");
  let productPageAddToCartButton = jQuery("button.product-form__submit[name='add']");

  // Check if the membershipAgreement checkbox exists
  if (membershipAgreement.length) {
    // Attach a change event handler to the checkbox
    if (membershipAgreement.is(":checked")) {
      productPageAddToCartButton.prop("disabled", false);
      shopifyPaymentButton.show();
    } else {
      productPageAddToCartButton.prop("disabled", true);
      shopifyPaymentButton.hide();
    }
    membershipAgreement.change(function () {
      // Check if the checkbox is checked
      if (jQuery(this).is(":checked")) {
        console.log("checked");
        // Disable the Add to Cart button
        productPageAddToCartButton.prop("disabled", false);
        shopifyPaymentButton.show();
      } else {
        console.log("not checked");
        // Enable the Add to Cart button
        productPageAddToCartButton.prop("disabled", true);
        shopifyPaymentButton.hide();
      }
    });
  }
  // BackToTop Button script
  let backtoptop = jQuery(".back-to-top-button");
  // When the user scrolls down 20px from the top of the document, show the button
  jQuery(window).scroll(function () {
    scrollFunction();
  });

  function scrollFunction() {
    if (jQuery(document).scrollTop() > 20) {
      backtoptop.css("display", "block");
    } else {
      backtoptop.css("display", "none");
    }
  }

  // When the user clicks on the button, scroll to the top of the document
  backtoptop.click(function () {
    jQuery("body,html").scrollTop(0);
  });
  // Accordion popup Modal Script
  const btnModal = jQuery("#btn-modal");
  const modal = jQuery("#modal-body-element");
  if (btnModal.length) {
    btnModal.on("click", function () {
      modal.css({
        display: "block",
        background: "#0000009e",
      });
      modal.addClass("show");
    });
  }

  // Footer email newsletter script started
  const newsletterSubBtn = jQuery(".subscibe-primary_btn");
  const newsletterInputField = jQuery("#footer_email_newsletter");
  const newsletterSubBtnSubTag = newsletterSubBtn.data("subscribe-tag");

  function validateEmail(email) {
    if (!email || email.trim() === "") {
      return false; // Email is empty or null
    }

    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test(email);
  }

  newsletterInputField.click(function () {
    newsletterSubBtn.val("Subscribe");
    newsletterSubBtn.prop("disabled", false);
  });

  if (newsletterSubBtn.length) {
    if (newsletterSubBtnSubTag) {
      newsletterSubBtn.click(async function () {
        if (validateEmail(newsletterInputField.val())) {
          let $this = jQuery(this);
          $this.val("Subscribing...");
          try {
            fetch(
              `https://hyperkarting.sfmcshopify.com/api/shopify/subscribe?email=${newsletterInputField.val()}&coupon=${newsletterSubBtnSubTag}`
            )
              .then((res) => {
                if (res.ok) {
                  return res.json();
                }
                return res.json().then((response) => {
                  throw new Error(response.error);
                });
              })
              .then((data) => {
                const { customer } = data;
                if (customer.isCustomerAlreadySubscribed === true) {
                  $this.val("Already Subscribed 😎");
                  $this.prop("disabled", true);
                  newsletterInputField.val("");
                } else {
                  $this.val("Subscribed 👌");
                  newsletterInputField.val("");
                  window.location.href = "/pages/newsletter-thank-you";
                }
                console.log(customer);
              })
              .catch((error) => console.error(error));
          } catch (e) {
            console.log("error", e);
          }
        } else {
          alert("Oops! empty email field can not be submitted!");
        }
      });
    } else {
      newsletterSubBtn.click(async function () {
        if (validateEmail(newsletterInputField.val())) {
          let $this = jQuery(this);
          $this.val("Subscribing...");
          try {
            fetch(
              `https://hyperkarting.sfmcshopify.com/api/shopify/subscribe?email=${newsletterInputField.val()}`
            )
              .then((res) => {
                if (res.ok) {
                  return res.json();
                }
                return res.json().then((response) => {
                  throw new Error(response.error);
                });
              })
              .then((data) => {
                const { customer } = data;
                if (customer.isCustomerAlreadySubscribed === true) {
                  $this.val("Already Subscribed 😎");
                  $this.prop("disabled", true);
                  newsletterInputField.val("");
                } else {
                  $this.val("Subscribed 👌");
                  newsletterInputField.val("");
                  window.location.href = "/pages/newsletter-thank-you";
                }
                console.log(customer);
              })
              .catch((error) => console.error(error));
          } catch (e) {
            console.log("error", e);
          }
        } else {
          alert("Oops! empty email field can not be submitted!");
        }
      });
    }
  }
  // Footer email newsletter script ended
});
